import React from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";

export const BlogPostLoading = () => (
  <main className="py-28 min-h-[50vh] flex items-center justify-center" data-testid="blog-post-loading">
    <Loader2 className="w-7 h-7 text-[#C8703A] animate-spin" />
  </main>
);

export const BlogPostNotFound = () => (
  <main className="py-24 px-6" data-testid="blog-post-error">
    <div className="max-w-2xl mx-auto text-center">
      <h1 className="font-fraunces font-extrabold text-3xl text-[#1F1F1C] mb-4">Article not found</h1>
      <p className="text-[#4A463F] mb-8">That article does not exist any more.</p>
      <Link to="/insights" className="inline-flex items-center gap-2 text-[#C8703A] font-semibold hover:underline underline-offset-4">
        <ArrowLeft className="w-4 h-4" /> Back to Insights
      </Link>
    </div>
  </main>
);
